import {useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {obtenerPuntosVenta, obtenerArchivos} from "../AccionesBackend";
import {Col, Container, Row, Modal, Button, Dropdown, DropdownButton, FormControl} from "react-bootstrap";
import {BotonRegresar} from "../BotonRegresar";

export const PuntoVenta = () => {
    const {estado} = useParams(); // Se recibe el estado en la URL
    const [punto, setPunto] = useState(null);
    const [puntosEstado, setPuntosEstado] = useState([]); // Lista de puntos de venta en el estado
    const [selectedPuntoId, setSelectedPuntoId] = useState(null); // Se almacenará como cadena
    const [imgModuloUrl, setImgModuloUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // 1. Obtener todos los puntos de venta para el estado indicado
    useEffect(() => {
        const fetchPuntosVenta = async () => {
            try {
                const result = await obtenerPuntosVenta();
                if (result.success && result.puntosVenta) {
                    // Filtrar los puntos cuyo campo "estado" coincida (sin distinguir mayúsculas/minúsculas)
                    const puntosFiltrados = result.puntosVenta.filter(
                        (p) =>
                            p.estado.toLowerCase() === decodeURIComponent(estado).toLowerCase()
                    );
                    setPuntosEstado(puntosFiltrados);
                    if (puntosFiltrados.length > 0) {
                        // Usar el primer punto como default (convertir su id a cadena)
                        if (!selectedPuntoId) {
                            setSelectedPuntoId(puntosFiltrados[0].id.toString());
                        }
                    } else {
                        setError("No hay puntos de venta para este estado");
                    }
                } else {
                    setError("Punto de venta no encontrado");
                }
            } catch (err) {
                console.error("Error al obtener los puntos de venta:", err);
                setError("Error al obtener los puntos de venta");
            } finally {
                setLoading(false);
            }
        };

        fetchPuntosVenta();
    }, [estado]);

    // 2. Cuando cambie la selección, actualizar el punto mostrado
    useEffect(() => {
        if (puntosEstado.length > 0 && selectedPuntoId) {
            const puntoData = puntosEstado.find(
                (p) => p.id.toString() === selectedPuntoId
            );
            if (puntoData) {
                setPunto(puntoData);
            }
        }
    }, [selectedPuntoId, puntosEstado]);

    // 3. Obtener la imagen asociada al punto seleccionado
    useEffect(() => {
        const fetchImgModulo = async () => {
            if (punto && punto.imgModulo_id) {
                try {
                    const result = await obtenerArchivos({archivoId: punto.imgModulo_id});
                    if (result.success && result.archivos && result.archivos.length > 0) {
                        setImgModuloUrl(result.archivos[0].ruta_archivo);
                    }
                } catch (err) {
                    console.error("Error al obtener el archivo:", err);
                }
            }
        };

        fetchImgModulo();
    }, [punto]);

    // Funciones para controlar la visibilidad del modal
    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    // Agrupar los puntos de venta por localidad
    const groupedPuntos = puntosEstado.reduce((acc, punto) => {
        const localidad = punto.localidad || "Sin localidad";
        if (!acc[localidad]) {
            acc[localidad] = [];
        }
        acc[localidad].push(punto);
        return acc;
    }, {});

    if (loading) {
        return <p>Cargando punto de venta...</p>;
    }

    if (error || !punto) {
        return <h2>{error || "Punto de venta no encontrado"}</h2>;
    }

    const PuntoVentaDropdown = ({groupedPuntos, selectedPuntoId, setSelectedPuntoId}) => {
        const [searchTerm, setSearchTerm] = useState("");

        // Convertimos el objeto groupedPuntos en una lista de puntos filtrados por el término de búsqueda
        const filteredPuntos = Object.keys(groupedPuntos).reduce((acc, localidad) => {
            const puntosFiltrados = groupedPuntos[localidad].filter((p) =>
                p.direccion.toLowerCase().includes(searchTerm.toLowerCase())
            );
            if (puntosFiltrados.length > 0) {
                acc[localidad] = puntosFiltrados;
            }
            return acc;
        }, {});

        return (
            <Container>
            <BotonRegresar/>
            <DropdownButton
                title={
                    selectedPuntoId
                        ? groupedPuntos[
                        Object.keys(groupedPuntos).find((localidad) =>
                            groupedPuntos[localidad].some((p) => p.id.toString() === selectedPuntoId)
                        )
                        ]?.find((p) => p.id.toString() === selectedPuntoId)?.title || "Selecciona un punto de venta"
                        : "Selecciona un punto de venta"
                }
                variant="secondary"
                className="mb-3"
            >
                {/* Barra de búsqueda dentro del dropdown */}
                <div className="px-3 pb-2">
                    <FormControl
                        type="text"
                        placeholder="Buscar punto de venta..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                {/* Lista de puntos de venta filtrados */}
                {Object.keys(filteredPuntos).length > 0 ? (
                    Object.keys(filteredPuntos).map((localidad) => (
                        <div key={localidad}>
                            <Dropdown.Header>{localidad}</Dropdown.Header>
                            {filteredPuntos[localidad].map((p) => (
                                <Dropdown.Item
                                    key={p.id}
                                    onClick={() => setSelectedPuntoId(p.id.toString())}
                                    active={p.id.toString() === selectedPuntoId}
                                >
                                    {p.title}
                                </Dropdown.Item>
                            ))}
                        </div>
                    ))
                ) : (
                    <Dropdown.ItemText className="text-center text-muted">No se encontraron
                        resultados</Dropdown.ItemText>
                )}
            </DropdownButton>
            </Container>
        );
    };

    return (
        <section style={{paddingTop: "120px"}}>
            <Container>
                <div className="banner-lineamientos">
                    <h1>{punto.estado}</h1>
                </div>

                <div style={{marginBottom: "20px"}}>
                    <PuntoVentaDropdown
                        groupedPuntos={groupedPuntos}
                        selectedPuntoId={selectedPuntoId}
                        setSelectedPuntoId={setSelectedPuntoId}
                    />
                </div>

                <Row>
                    <Col
                        className="d-flex flex-column justify-content-center align-items-center"
                        md={6}
                    >
                        <img
                            src={imgModuloUrl || "ruta-fallback-para-imagen"}
                            alt={`Imagen de ${punto.estado}`}
                            style={{maxWidth: "500px", height: "500px", borderRadius: "8px"}}
                        />
                        <Button className="button_id mt-2" onClick={handleShow}>
                            Ver detalles
                        </Button>
                    </Col>
                    <Col
                        className="d-flex flex-column justify-content-center align-items-center"
                        md={6}
                    >
                        <iframe
                            title="mapa"
                            src={`https://www.google.com/maps?q=${punto.latitud},${punto.longitud}&z=15&output=embed`}
                            style={{width: "500px", height: "500px", borderRadius: "8px"}}
                        ></iframe>
                        <Button
                            className="button_id mt-2"
                            style={{padding: "10px 20px"}}
                            onClick={() => window.open(
                                `https://www.google.com/maps/dir/?api=1&destination=${punto.latitud},${punto.longitud}`,
                                "_blank"
                            )}
                        >
                            📍 ¿Cómo llegar?
                        </Button>

                    </Col>
                </Row>
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <p>
                        <strong>Dirección:</strong> {punto.direccion}
                    </p>
                    <p>
                        <strong>Descripción:</strong> {punto.description}
                    </p>
                </div>
            </Container>

            {/* Modal con los detalles del punto de venta */}
            <Modal
                show={showModal}
                onHide={handleClose}
                centered
                size="lg"
                style={{paddingTop: "80px"}}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Detalles del Punto de Venta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row className="align-items-center">
                            <Col md={6}>
                                <img
                                    src={imgModuloUrl || "ruta-fallback-para-imagen"}
                                    alt={`Imagen de ${punto.estado}`}
                                    className="img-fluid rounded shadow"
                                />
                            </Col>
                            <Col md={6}>
                                <h2 className="fw-bold">{punto.title}</h2>
                                <p><strong>🗒️ Descripción:</strong> {punto.description}</p>
                                <p><strong>📌 Estado:</strong> {punto.estado}</p>
                                <p><strong>🏡 Localidad:</strong> {punto.localidad}</p>
                                <p><strong>📍 Dirección:</strong> {punto.direccion}</p>
                                <p><strong>🪛 Tipo de mueble:</strong> {punto.tipo_mueble}</p>
                                <p><strong>🔨 Estado del mueble:</strong> {punto.estado_mueble}</p>
                                <p><strong>📺 Televisión:</strong> {punto.television}</p>
                                <p><strong>❓ Televisión funcional:</strong> {punto.tv_funcional ? "Sí" : "No"}</p>
                                <p><strong>🖼️ Imágenes vinilos:</strong> {punto.imagen_viniles}</p>
                                <p><strong>⚡ Conexión de luz:</strong> {punto.conexion_luz ? "Sí" : "No"}</p>
                                <p><strong>🔑 Cuenta staff:</strong> {punto.conexion_luz ? "Sí" : "No"}</p>
                                <p><strong>💬 Comentarios:</strong> {punto.comentarios}</p>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </section>
    );
};
